<template>
  <div>
    <div>
      <el-form :inline="true" :model="queryForm" style="text-align:left;">
        <el-form-item label="综合查询:">
          <el-input
            v-model="queryForm.product"
            placeholder="请输入商品编码/商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="承销商:">
          <My-Select
            v-model="queryForm.agentCode"
            :objSelect="queryForm.agentCode"
            :options="agentList"
            :placeholder="agentPlaceholder"
            :optionBind="optionBindAgent"
            @changeSelct="changeQueryAgent"
            :clearable='true'
          ></My-Select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="query()">查询</el-button>
          <el-button type="primary" plain @click="personnelEditor('add')"
            >新建</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div>
      <My-table
        :configurationData="configurationData"
        :operation="operation"
        :getTableParam="getTableParam"
        ref="myTable"
      >
        <template #operation="scope">
          <el-button
            size="mini"
            type="primary"
            @click="personnelEditor('update', scope.row)"
            >修改</el-button
          >
        </template>
      </My-table>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="personnelEditorDialog"
      :close-on-click-modal="false"
      width="1200px"
    >
      <el-form
        :model="editorForm"
        :inline="true"
        :rules="rules"
        ref="editorForm"
        label-width="100px"
        style="text-align:left"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="承销商:" prop="agentCode" class="role-select">
              <My-Select v-model="editorForm.agentCode" :objSelect="editorForm.agentCode" :options="agentList" :placeholder="agentPlaceholder" :optionBind="optionBindAgent" @changeSelct="changeAgent" :clearable='true'></My-Select>  
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品编码:" prop="productCode" class="phone-input">
              <el-input v-model="editorForm.productCode" placeholder="请输入商品编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品名称:" prop="productName" class="phone-input">
              <el-input v-model="editorForm.productName" placeholder="请输入商品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态:" prop="state">
              <el-switch v-model="editorForm.state"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" style="text-align:center">
        <el-button type="primary" @click="submitForm('editorForm')"
          >确定</el-button
        >
        <el-button @click="resetForm('editorForm')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from "../../../public/static/common";
import  asyncApi   from '../../api/asyncApi';

export default {
  name: "productCode",
  data() {
    return {
      title: "",
      agentPlaceholder:'请选择承销商名称',
      operationType: "",
      queryForm: {
        agentCode: "",
        product: "",
        pageNum: 1,
        pageSize: 10,
        totalNum: 0
      },
      agentList: [],
      optionBindAgent:{
        label:"agentName",
        value:"agentCode"
      },
      // 列表配置
      configurationData: [
        {
          title: "承销商",
          propertys: "agentCode",
          width: "",
        },
        {
          title: "商品编码",
          propertys: "productCode",
          width: "",
        },
        {
          title: "商品名称",
          propertys: "productName",
          width: "",
        },
        {
          title: "状态",
          propertys: "stateName",
          width: ""
          // format: common.formatState,
        },
      ],
      // 是否有操作按钮 宽度
      operation: {
        show: true,
        width: "",
      },
      getTableParam: {
        url: "/extwarapi/api/product/page",
        param: "",
      },
      personnelEditorDialog: false,
      editorForm: {
        id: "",
        agentCode: "",
        agentName: "",
        state: true
        // createUser: "",
        // modifyUser: "",
        // sysCode: "PC", //人员管理都是PC端用户
      },
      rules: {
        productName: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        productCode: [{ required: true, message: "请输入商品编码", trigger: "blur" }],
        agentCode: [{ required: true, message: "请选择承销商", trigger: "blur" }]
      },
      branchCounter: 0
    }
  },
  methods: {
    // 列表状态处理
    formatState(row){        
      if(row.state=='Y'){
        return '使用中'
      }else if(row.state=='N'){
        return '停用中'
      }
    },
    personnelEditor(operationType, row) {
      this.branchCounter = 0
      this.operationType = operationType;
      if (operationType == "update") {
        this.title = "商品编码修改";
        let url = "/extwarapi/api/product/get"
        this.axios.post(url, {id:row.id}).then((resp) => {
          if(resp.data.code='0000'){
            this.editorForm=resp.data.result;
            if(this.editorForm.state=='Y'){
              this.editorForm.state=true;
            }else if(this.editorForm.state=='N'){
              this.editorForm.state=false;
            }
          }
        }).catch((resp) => {
            console.log('error', resp); 
        })     
      } else {
        //添加
        this.title = "商品编码新增";
        this.editorForm.state = true;
        // this.underwriterCheckList = [];
        this.editorForm = common.emptyModel(this.editorForm, ["state"]);
      }
      this.personnelEditorDialog = true;
    },
    async getDetail(param){
      let url = "/extwarapi/api/product/get"
      let data = await asyncApi.post(url,{id:param});
      if(data.code=='0000'){
        // console.log('datta',data)
        this.editorForm=data.result;
      }
    },
    query() {
      this.getTableParam.param = this.queryForm;
      this.$refs["myTable"].query(1);
    },
    //获取承销商数据字典
    async getAgentList(){
      let url ="/extwarapi/api/agent/getAgentEnum";
      let data = await asyncApi.post(url,null);
      if(data.code=='0000'){
        this.agentList=data.result;
      }
    },
    // 承销商选择
    changeQueryAgent(value) {
      // this.getAgentList()
      // console.log('agen1', this.queryForm)
      this.queryForm.agentCode = value
    },
    changeAgent(value){     
      // console.log('agen2', this.editorForm,value)      
      this.editorForm.agentCode=value;
    },
    submitForm(formName) {
      // let usercode = common.getCurrUser().userCode;
      let url = "";
      let param = Object.assign({}, this.editorForm);
      // param.createUser = usercode;
      // param.modifyUser = usercode;
      // console.log('param',param)
      if (param.state) {
        param.state = "Y";
      } else {
        param.state = "N";
      }
      // TODO
      if (this.operationType == "add") {
        url = "/extwarapi/api/product/add";
      } else {
        url = "/extwarapi/api/product/update";
      }
      let validate = ["productName","productCode","agentCode"]
      this.$refs[formName].validate((valid) => {
        // console.log('param',param)
        if (valid) {
          this.axios
            .post(url, param)
            .then((resp) => {
              if (resp.data.code == "0000") {
                this.$alert("操作成功!", "提示信息", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.personnelEditorDialog = false;
                    this.$refs["myTable"].query(1);
                  },
                });
              } else {
                this.$alert(resp.data.msg, "提示信息", {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
                return;
              }
            })
            .catch((resp) => {
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      // console.log('formName',formName)
      this.personnelEditorDialog = false;
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    this.getAgentList();
  },
};
</script>
<style lang="scss">
.username-input .el-input {
  width: 300px;
}
.role-select .el-input--suffix {
  width: 300px;
}
.phone-input .el-input {
  width: 300px;
}
</style>
